<div class="atmos-clock" [class.atmos-clock--right]="rightAlign()">
  <div class="atmos-clock__label">{{ label() }}</div>
  <div class="atmos-clock__time">{{ time() }}</div>
  @if (subtle()) {
    <div class="atmos-clock__subtle">{{ subtle() }}</div>
  }
  <ng-content />
</div>
